import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const Expenses: React.FC = () => {
  const { user } = useAuth();

  // Redirect superadmin to the new expense management page
  if (user?.roles?.includes("superadmin")) {
    return <Navigate to="/expense-management" replace />;
  }

  // For other users, show a simple message or redirect to appropriate page
  return (
    <div className="p-4">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <h2 className="text-lg font-semibold text-yellow-800 mb-2">
          Access Restricted
        </h2>
        <p className="text-yellow-700">
          Expense management is available for super administrators. Please
          contact your system administrator if you need access.
        </p>
      </div>
    </div>
  );
};

export default Expenses;
